import React from 'react'

import arrowSrc from './arrow.svg'
import ThreeCircles from './three-circles.svg'
import CloseChat from './close-chat.js'
import InactiveFill from './rectangle.svg'

import { variation } from 'modules/experiment/helpers'
import { messagesByLocale } from 'utils/translations'

import './style.css'

const CustomMessage = ({
  welcomeMessage,
  email,
  name,
  color,
  locale
}) => {
  return (
    <div className="custom-message">
      <div className="custom-message-text">
        <p>
          This is what your welcome message looks like.
        </p>
        <img src={arrowSrc} alt=''/>
      </div>
      <div className="custom-message-widget">
        <div className="custom-message-widget-header" style={{ background: `#${color}`}}>
          <div className="custom-message-widget-name-container">
            <span className="custom-message-widget-name">{name || email}</span>
            <img alt='' src={ThreeCircles} />
          </div>
          <span>{welcomeMessage || messagesByLocale[locale]["app.newConversation.welcomeMessage"]}</span>
        </div>
        <div className="custom-message-widget-footer">
          <img alt='' src={InactiveFill} />
        </div>
      </div>
      <div className="custom-message-widget-close">
        {variation("touchless-twostep-experiment")==="on" && <span className="custom-message-copy-exp">You can change the color and message later</span>}
        <CloseChat color={color}/>
      </div>
    </div>
  )
}

export default CustomMessage